/**
 * apiBaseUrl.js — Détermination de l'URL du serveur backend
 *
 * Retourne l'URL de base de l'API selon l'environnement :
 *  - Variable d'env REACT_APP_API_BASE_URL si définie (déploiement personnalisé)
 *  - localhost:8000 si on est en développement local
 *  - URL Render en production
 */
export function getApiBaseUrl() {
	// Priorité 1 : variable d'environnement définie dans .env
	const configuredBaseUrl = String(process.env.REACT_APP_API_BASE_URL || '').trim().replace(/\/$/, '');
	if (configuredBaseUrl) {
		return configuredBaseUrl;
	}

	if (typeof window !== 'undefined') {
		// Priorité 2 : développement local
		if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
			return 'http://localhost:8000';
		}

		// Priorité 3 : serveur de production hébergé sur Render
		return 'https://ultimatex-backend.onrender.com';
	}

	return 'http://localhost:8000';
}
